module.exports = __webpack_public_path__ + "img/_checked.64b20db1.svg";